import {AbstractControl, ValidatorFn} from '@angular/forms';

import {ExecutionsSymbolValidatorKey} from './custom-validator-keys';

export function ExecutionsSymbolsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        const regex = new RegExp(/^[a-zA-Z0-9\-.$+*#!@^=~]+$/);

        return !regex.test(controlValue) ? {[ExecutionsSymbolValidatorKey]: true} : null;
    };
}
